import { render, staticRenderFns } from "./ringChart.vue?vue&type=template&id=95760300"
import script from "./ringChart.vue?vue&type=script&lang=js"
export * from "./ringChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports